module.exports = __webpack_public_path__ + "static/media/logo.7ac3ba3a.svg";